import WinBase from "./winBase";
import WinUtils from "../../../winUtils";

class ShowFileUploadWin extends WinBase {
    constructor(options) {
        super(options);
        let defConfig = {};
        this.options = $.extend(defConfig, options);
    }

    //显示附件上传窗口
    showWin(params) {
        let options = {
            width: 500,
            height: 350,
            url: params.fileDivId,
            params: "",
            showBottomBar: true,
            title: "上传附件",
            confirmBtn: function (winId, closeWinFun) {
                params.confirmBtn(closeWinFun);
            },
            anim: null
        };
        WinUtils.showInfoOnWin(options);
    }
}

export default ShowFileUploadWin;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/go-dialog/components/showFileUploadWin.js